<div class="none-login-header-container mat-elevation-z3">
  <div class="none-login-header__logo">
    <a routerLink="/"><img src="https://pex-static.s3-ap-northeast-1.amazonaws.com/profiee-teams-logo.svg"></a>
  </div>
  <div class="none-login-header__actions">
  </div>
</div>
